import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { bool } from 'prop-types';
import { CustomSwitch } from '../../../../../atoms';
import SubTitle from '../../SubTitle';
import Title from '../../Title';
import { useAuthCredentials } from '../hooks/useAuthCredentials';
import { useValidationMessage } from './hooks';
import { useNodeDataToSave } from './hooks/useNodeDataToSave';
import { StyledBox, StyledFormControl } from './styled';

const WebhookBasicAuth = ({ noMargin }) => {
  const { t } = useTranslation();
  const validationUsernameMessage = useValidationMessage('username');
  const validationPasswordMessage = useValidationMessage('password');
  const [{ useBasicAuthentication, authenticationType }, updateDataToSave] = useNodeDataToSave();
  const { username, password } = useAuthCredentials();
  const [isUseAuth, setIsUseAuth] = useState(true);

  useEffect(() => {
    if (!authenticationType) {
      updateDataToSave({ authenticationType: useBasicAuthentication ? 'BASIC' : 'NONE' });
    }
    if (useBasicAuthentication === false || authenticationType === 'NONE') {
      setIsUseAuth(false);
    }
  }, [useBasicAuthentication, authenticationType, updateDataToSave]);

  const onSwitch = (isAuth) => {
    setIsUseAuth(isAuth);
    if (typeof useBasicAuthentication !== 'undefined') {
      updateDataToSave({ useBasicAuthentication: isAuth });
    }
    if (typeof authenticationType !== 'undefined') {
      updateDataToSave({ authenticationType: isAuth ? 'BASIC' : 'NONE' });
    }
  };

  const onChange = (type, { target }) => {
    updateDataToSave({ [type]: target.value });
  };

  return (
    <Box>
      <StyledBox>
        <Box>
          <Title mt={noMargin ? '0' : '40px'}>{t('Authentication')}</Title>
          <SubTitle>{t('Set up authentication (Optional)')}</SubTitle>
        </Box>
        <StyledBox>
          <CustomSwitch checked={isUseAuth} onClick={() => onSwitch(!isUseAuth)} />
        </StyledBox>
      </StyledBox>
      {isUseAuth && (
        <Box marginBottom="24px">
          <Title fontSize="12px" mt="0">
            {t('Username')}
          </Title>
          <StyledFormControl error={Boolean(validationUsernameMessage)} fullWidth>
            <TextField
              variant="standard"
              value={username ?? ''}
              onChange={(e) => onChange('username', e)}
              placeholder="Enter username"
            />
            <FormHelperText>{validationUsernameMessage}</FormHelperText>
          </StyledFormControl>
          <Title fontSize="12px">{t('Password')}</Title>
          <StyledFormControl error={Boolean(validationPasswordMessage)} fullWidth>
            <TextField
              variant="standard"
              value={password ?? ''}
              onChange={(e) => onChange('password', e)}
              placeholder="Enter password"
            />
            <FormHelperText>{validationPasswordMessage}</FormHelperText>
          </StyledFormControl>
        </Box>
      )}
    </Box>
  );
};

WebhookBasicAuth.propTypes = {
  noMargin: bool,
};

WebhookBasicAuth.defaultProps = {
  noMargin: false,
};

export default WebhookBasicAuth;
